export default __webpack_public_path__ + "static/media/14.607feca5.JPG";